import React from 'react';
import Navbar from './components/Navbar/Navbar';
import HomeSection from './components/Section/HomeSection'
import AboutSection from './components/Section/AboutSection'
import ServiceSection from './components/Section/ServicesSection'
import './App.css'
import ContactSection from './components/Section/ContactSection';
import { Helmet } from "react-helmet";




const App = () => {
  return (
    <div>
          <Helmet>
            <title>Gärtner Lindau | Gartenpflege & Gestaltung – Natuerlik</title>
            <meta
              name="description"
              content="Ihr Gärtner in Lindau für Gartenpflege, Heckenschnitt und naturnahe Gartengestaltung im Bodensee-Raum. Jetzt anfragen!"
            />
          </Helmet>
          <HomeSection
            id="home"
            title="Natür-lik"
            content="Lassen Sie Ihren Garte auf was neues ein!"
          />
          <AboutSection
            id="about"
            title="Über mich"
            backgroundColor="#333333"
          />
          
          {
          /*
          <ServicesHeaderSection
            id="headerservices"
        
          />
          
          */
          }
          
          
        
          

          <ServiceSection
            id="services"
            title="Was ich Ihnen bieten kann"
            bg_image={"/images/services_background.jpeg"}
          />
          <ContactSection
            id="contact"
            title="Kontakt"
          />

          
          
          
    </div>
  );
};

export default App;
